<ng-container *ngIf="enableTopFour">
  <ng-container
    *ngIf="collectionData?.contentTop && collectionData.contentBottom"
  >
    <eds-card-promo
      [contentTop]="collectionData?.contentTop"
      [contentBottom]="collectionData?.contentBottom"
    >
    </eds-card-promo>
  </ng-container>
</ng-container>
<div
  edsPadding
  *ngIf="this.collectionData?.collections.length > 0"
  [edsPaddingTop]="enableTopFour ? 'xxl' : ''"
>
  <eds-sidebar
    [label]="translationLabel?.articlesCollection"
    [hasShadows]="false"
    [hasBorders]="false"
    [hasPadding]="false"
  >
    <div *ngFor="let article of collectionData?.collections; let i = index">
      <a
        [href]="article.url"
        [target]="article.target"
        [ngClass]="article.external ? 'external-link' : ''"
        [title]="article.title"
        class="sidebar__list-item sidebar__list-item--grey1"
        edsFlexbox
        alignItems="center"
        justifyContent="space-between"
        edsPadding
        edsPaddingBottom="sm"
      >
        <div edsPadding edsPaddingRight="xs">
          <p class="bold spacing--none">
            {{ article.displayText }}
          </p>
        </div>

        <eds-icon
          class="sidebar__icon--primary"
          type="carrot-right"
          size="small"
        ></eds-icon>
      </a>
      <eds-divider
        *ngIf="i < collectionData?.collections?.length - 1"
        edsPadding
        edsPaddingBottom="sm"
      ></eds-divider>
    </div>
  </eds-sidebar>
</div>
